// TODO: Replace all occurrences of 'YYYY-MM-DD' with this.
export const YEAR_MONTH_DAY = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mmZZ';
